import { render, staticRenderFns } from "./ThumbsUp.vue?vue&type=template&id=57fed257&"
import script from "./ThumbsUp.vue?vue&type=script&setup=true&lang=js&"
export * from "./ThumbsUp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports